import { CameraFill, Xmark } from '@peacecover/icon';
import HorizontalScroll from '../../my-page/components/HorizontalScroll';
import type { FileContent } from 'use-file-picker/dist/interfaces';
import { useFilePicker } from 'use-file-picker';
import { useEffect } from 'react';

interface ImageUploadSectionProps {
  imageFiles: FileContent<string>[];
  setImageFiles: (
    files: FileContent<string>[] | ((prev: FileContent<string>[]) => FileContent<string>[])
  ) => void;
}

const ImageUploadSection = ({ imageFiles, setImageFiles }: ImageUploadSectionProps) => {
  const { openFilePicker, filesContent, clear } = useFilePicker({
    readAs: 'DataURL',
    accept: 'image/*',
    multiple: true
  });

  // 기존 이미지와 새로 선택된 이미지를 합치되, 10개 제한
  useEffect(() => {
    if (filesContent.length > 0) {
      const totalImages = imageFiles.length + filesContent.length;

      if (totalImages <= 10) {
        setImageFiles((prev) => [...prev, ...filesContent]);
      } else {
        const remainingSlots = 10 - imageFiles.length;
        const imagesToAdd = filesContent.slice(0, remainingSlots);
        setImageFiles((prev) => [...prev, ...imagesToAdd]);
      }

      clear();
    }
  }, [filesContent, imageFiles.length, clear, setImageFiles]);

  const handleAddImageClick = () => {
    if (imageFiles.length < 10) {
      openFilePicker();
    }
  };

  return (
    <HorizontalScroll>
      <div className="flex gap-[12px] px-[24px] pt-[9px] pb-[16px]">
        <button
          type="button"
          className="border border-separator-light-1 dark:border-separator-dark-1 px-[25px] py-[17px] rounded-[12px] flex-shrink-0"
          onClick={handleAddImageClick}
        >
          <CameraFill className="text-text-main-lv1" />
          <p className="text-[12px] text-sub-light-1 dark:text-sub-dark-1">
            {imageFiles.length}/10
          </p>
        </button>
        {imageFiles.map((file, index) => (
          <div
            key={`${file.name}-${file.lastModified}-${index}`}
            className="flex flex-col w-[75px] h-[75px] rounded-[12px] relative flex-shrink-0"
          >
            <img
              src={file.content}
              alt={`Attached ${index + 1}`}
              className="w-[75px] h-[75px] object-cover rounded-[12px]"
            />
            <button
              type="button"
              className="absolute -top-[9px] -right-[9px] w-[24px] h-[24px] flex items-center justify-center bg-primary-light rounded-full"
              onClick={() => {
                setImageFiles((prev) => prev.filter((_, i) => i !== index));
              }}
            >
              <Xmark className="text-on-primary" size={13} />
            </button>
          </div>
        ))}
      </div>
    </HorizontalScroll>
  );
};

export default ImageUploadSection;
